import { useTranslation } from "react-i18next";
import { partners } from "@/mocks/highlights";

export default function PartnersMarquee() {
  const { t } = useTranslation();
  const doubled = [...partners, ...partners];
  return (
    <section className="w-full py-16 md:py-20 bg-background-50 border-y border-background-200/70 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-8 mb-10 text-center">
        <div className="text-primary-600 text-xs md:text-sm tracking-[0.3em] font-medium mb-3">
          {t("partners.label")}
        </div>
        <h2 className="font-heading font-bold text-foreground-950 text-3xl md:text-4xl">
          {t("partners.title")}
        </h2>
      </div>
      <div className="relative overflow-hidden">
        <div className="flex gap-16 animate-marquee whitespace-nowrap w-max">
          {doubled.map((p, i) => (
            <div
              key={i}
              className="flex items-center gap-3 text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer"
            >
              <span className="w-2 h-2 rounded-full bg-accent-500"></span>
              <span className="font-heading text-lg md:text-2xl">{p}</span>
            </div>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-background-50 to-transparent"></div>
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-background-50 to-transparent"></div>
      </div>
    </section>
  );
}